(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smarthold-invoice"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('smarthold-invoice')){
customElements.define('smarthold-invoice',class extends HTMLElement{
connectedCallback(){
this.select=this.querySelector('#sh-document');this.grid=this.querySelector('.sh-invoice-grid');this.status=this.querySelector('[role="status"]');this.queue=Promise.resolve();this.ready=false;
this.toggle();
this.addEventListener('input',()=>{clearTimeout(this.timer);this.status.textContent='';this.timer=setTimeout(()=>{this.toggle();this.validateRut();this.save().catch(()=>{});},350);});
this.addEventListener('change',()=>{this.toggle();this.validateRut();this.save().catch(()=>{});});
this.form=document.getElementById('cart');
this.handler=async(e)=>{if(this.ready){this.ready=false;return;}if(e.submitter?.name!=='checkout')return;e.preventDefault();this.validateRut();if(!this.form.reportValidity())return;const button=e.submitter;button.disabled=true;try{await this.save();this.ready=true;button.disabled=false;this.form.requestSubmit(button);}catch{button.disabled=false;}};
this.form?.addEventListener('submit',this.handler);
}
disconnectedCallback(){this.form?.removeEventListener('submit',this.handler);}
toggle(){const yes=Array.from(this.grid.querySelectorAll('input')).some(input=>input.value.trim());this.select.value=yes?'Factura':'Boleta';}
validateRut(){const input=this.querySelector('#sh-rut');input.setCustomValidity('');if(this.select.value!=='Factura'||!input.value)return;const rut=input.value.replace(/[.\s-]/g,'').toUpperCase();if(!/^\d{7,8}[0-9K]$/.test(rut)){input.setCustomValidity(this.dataset.rutError);return;}let sum=0,m=2;for(let i=rut.length-2;i>=0;i--){sum+=Number(rut[i])*m;m=m===7?2:m+1;}const n=11-sum%11;const dv=n===11?'0':n===10?'K':String(n);if(dv!==rut.at(-1))input.setCustomValidity(this.dataset.rutError);}
save(){this.status.textContent='';const attributes={};this.querySelectorAll('[name]').forEach(input=>{attributes[input.name.slice(11,-1)]=input.value.trim();});const task=this.queue.catch(()=>{}).then(async()=>{const response=await fetch(this.dataset.updateUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes})});if(!response.ok)throw new Error('save');const cart=await response.json();for(const [key,value] of Object.entries(attributes)){if(value&&(cart.attributes[key]!==value))throw new Error('verify');}this.status.textContent=this.dataset.saved;});this.queue=task;return task.catch(error=>{this.status.textContent=this.dataset.error;throw error;});}
});
}

  } catch(e) { console.error(e); }
})();
})();
